module.exports = __webpack_public_path__ + "static/media/goncalo_pereira.fd697c0d.jpg";